var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoughShared = function SvgRoughShared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.5 5H16.11L5 20l7.5 23h16.595v-3H15L8.5 20.5l9-12.5H26l10.73 15.715h3.662z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43H32v-.95q0-2.1 2.125-3.425T40 37.3t5.875 1.325T48 42.05zM42.575 33.229Q41.5 34.3 39.996 34.3t-2.575-1.075-1.071-2.579 1.075-2.575T40.004 27t2.575 1.075 1.071 2.579-1.075 2.575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.757 28.04 24.464-10.462.393.92L10.15 28.96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.919 12.158 23.38 22.81l-.713.7-10.463-10.65z"
  })));
};
export default SvgRoughShared;